export const features = [
  {
    img: "focus.svg",
    title: "فضای کاری امن آبالون",
    desc: "پلتفرم فضای کاری امن آبالون، امکان دسترسی ایمن به منابع و ابزارهای مورد نیاز را از طریق دسکتاپ ابری مبتنی بر مرورگر از هر کجا فراهم می‌کند.",
    imgAlt: "فضای کاری امن آبالون",
    imgTitle: "فضای کاری امن آبالون",
  },
  {
    img: "monitoring.svg",
    title: "سامانه تحلیل و پایش امنیتی (SOC)",
    desc: "راهکار SOC، ترافیک شبکه و زیرساخت سازمان را به‌صورت مستمر پایش و تحلیل می‌کند تا تهدیدات قبل از تبدیل شدن به بحران شناسایی شوند.",
    imgAlt: "سامانه تحلیل و پایش امنیتی (SOC)",
    imgTitle: "سامانه تحلیل و پایش امنیتی (SOC)",
    imgAlt: "اطمینان بالا در سرور مجازی ابری",
    imgTitle: "اطمینان بالای وی پی اس",
  },
  {
    img: "technical.svg",
    title: "سرویس PAM ابری",
    desc: "با راهکار PAM ابری دسترسی حساب‌های کاربری به منابع حساس سازمان را کنترل و نشست‌های کاری را برای بازبینی‌های آینده به‌صورت تصویری ضبط کنید.",
    imgAlt: "سرویس PAM ابری",
    imgTitle: "سرویس PAM ابری",
  },
  {
    img: "devops.svg",
    title: "فایروال وب (WAF)",
    desc: "راهکار WAF ترافیک ورودی در لایه اپلیکشین به برنامه‌های تحت وب را بررسی و از حملاتی مانند SQL Injection و XSS محافظت می‌کند.",
    imgAlt: "فایروال وب (WAF)",
    imgTitle: "فایروال وب (WAF)",
  },
  {
    img: "agility.svg",
    title: "محافظت در برابر حملات DDoS",
    desc: "با استفاده از خدمات محافظت در برابر DDoS، ترافیک مخرب را در لحظه شناسایی و مسدود کنید تا سرویس‌های شما بدون اختلال در دسترس باقی بماند.",
    imgAlt: "محافظت در برابر حملات DDoS",
    imgTitle: "محافظت در برابر حملات DDoS",
  },
  {
    img: "hardening.svg",
    title: "فایروال لایه۳/لایه۴",
    desc: `با فایروال ابری یکپارچه با <a href="/cdn" class="blue--text text--darken-3 font-weight-bold" target="_blank">«سرویس CDN»</a>، دسترسی کاربران را به‌کمک فیلتراسیون پیشرفته بر اساس IP ،URL، سیستم‌عامل و پروتکل محدود کنید.`,
    imgAlt: "فایروال لایه۳/لایه۴",
    imgTitle: "فایروال لایه۳/لایه۴",
  },
];

export const solotionTabItems = [
  {
    title: "فایروال وب (WAF)",
    img: "cdn/domain.svg",
    imgAlt: "فایروال وب (WAF) آبالون",
    imgTitle: "فایروال وب (WAF) آبالون",
    img_deactive: "cdn/domain.svg",
    section_title: "فایروال وب (WAF)",
    caption:
      "راهکار WAF آبالون یک لایه دفاعی پیشرفته برای محافظت از اپلیکیشن‌های وب سازمانی در برابر تهدیدات لایه ۷ فراهم می‌کند. این سرویس، بدون نیاز به خرید یا مدیریت تجهیزات سخت‌افزاری و با استفاده از رول‌ست‌های پیشرفته، تحلیل هوشمند ترافیک و شناسایی الگوهای مشکوک، امنیت ابری پایدار و مقیاس‌پذیر برای سرویس‌های تحت وب ایجاد می‌کند.",
    contentImg: "cdn/CDN-Header.svg",
    contentImgAlt: "فایروال وب (WAF) آبالون",
    contentImgTitle: "فایروال وب (WAF) آبالون",
    link: "/waf",
    linkTitle: "آشنایی با  راهکار WAF آبالون",
    alt: "فایروال وب (WAF)",
    contentItem: [
      {
        name: "مجموعه قوانین WAF (رول‌ست) با امکان فعال‌سازی‌ همزمان",
      },
      {
        name: "تشخیص و دفاع در لایه اپلیکیشن",
      },
      {
        name: "به‌روز‌رسانی جدیدترین قوانین WAF در ۳۰۰ میلی‌ثانیه",
      },
      {
        name: "کمتر از یک میلی‌ثانیه، تاثیر تاخیر WAF بر تجربه کاربران",
      },
    ],
  },
  {
    title: "سرویس PAM ابری",
    img: "cdn/report.svg",
    imgAlt: "سرویس PAM ابری آبالون",
    imgTitle: "سرویس PAM ابری آبالون",
    img_deactive: "cdn/report.svg",
    section_title: "سرویس PAM ابری",
    caption:
      "سرویس PAM ابری آبالون، راهکاری تخصصی برای کنترل و ایمن‌سازی دسترسی کاربران ممتاز (Privileged Users) به منابع حیاتی سازمان است. این سرویس با ارائه ابزارهایی برای مدیریت دسترسی، ثبت کامل نشست‌ها و امکان پاسخ سریع به رفتار غیرعادی، سطح امنیت ابری را در محیط‌های ابری و هیبریدی ارتقاء می‌دهد.",
    contentImg: "security/waf-banner.svg",
    contentImgAlt: "سرویس PAM ابری آبالون",
    contentImgTitle: "سرویس PAM ابری آبالون",
    link: "/pam",
    linkTitle: "آشنایی با  راهکار PAM ابری آبالون",
    alt: "آشنایی با  راهکار PAM ابری آبالون",
    contentItem: [
      {
        name: "کنترل دسترسی‌های تمام کاربران (مستقر در سازمان، دورکار یا با دسترسی موقت)",
      },
      {
        name: "ضبط کامل فعالیت‌های کاربران به‌صورت ویدئویی",
      },
      {
        name: "شناسایی رفتار مشکوک و قطع اتصال کاربر",
      },
      {
        name: "احراز هویت چندمرحله‌ای و دقیق برای کاربران",
      },
    ],
  },
  {
    title: "محافظت در برابر حملات DDoS",
    img: "cdn/ddos.svg",
    imgAlt: "محافظت در برابر حملات DDoS",
    imgTitle: "محافظت در برابر حملات DDoS",
    img_deactive: "cdn/ddos.svg",
    section_title: "محافظت در برابر حملات DDoS",
    caption:
      "سرویس محافظت در برابر حملات DDoS آبالون، راهکاری تخصصی برای شناسایی، فیلتر و دفع ترافیک مخرب در لایه‌‌های ۳، ۴ و ۷ است. این سرویس با یکپارچگی کامل با زیرساخت CDN آبالون، به‌صورت پیوسته حجم بالای درخواست‌های غیرعادی را تحلیل کرده و بدون نیاز به تجهیزات فیزیکی، امنیت ابری و در دسترس‌بودن سرویس‌های سازمانی را بهبود می‌دهد.",
    contentImg: "security/ddos-image.svg",
    contentImgAlt: "محافظت در برابر حملات DDoS",
    contentImgTitle: "محافظت در برابر حملات DDoS",
    link: "/ddos-protection",
    linkTitle: "آشنایی با خدمات محافظت از DDoS آبالون",
    alt: "خدمات محافظت از DDoS آبالون",
    contentItem: [
      {
        name: "دفع حملات در لایه‌های ۳، ۴ و ۷",
      },
      {
        name: "مقابله با حملات حجمی (ICMP/UDP/Spoofed packet floods)",
      },
      {
        name: "مقابله با حملات مبتنی بر پروتکل (UDP، SYN، و...)",
      },
      {
        name: "یکپارچگی کامل با شبکه توزیع محتوای آبالون (CDN)",
      },
    ],
  },
  {
    title: "سامانه تحلیل و پایش امنیتی (SOC)",
    img: "cdn/waf.svg",
    imgAlt: "سامانه تحلیل و پایش امنیتی (SOC)",
    imgTitle: "سامانه تحلیل و پایش امنیتی (SOC)",
    img_deactive: "cdn/waf.svg",
    section_title: "سامانه تحلیل و پایش امنیتی (SOC)",
    caption:
      "راهکار SOC آبالون با پایش دائمی شبکه، تحلیل بلادرنگ داده‌ها و شناسایی هوشمند تهدیدات، از تبدیل رخدادهای امنیتی به بحران جلوگیری می‌کند. این سامانه با ترکیب فناوری‌های SIEM ،EDR و XDR و همچنین مشارکت تیم تحلیل‌گر، همز‌مان با حفظ امنیت ابری از سرویس‌های سازمان در برابر حملات پیچیده محافظت می‌کند.",
    contentImg: "security/firewall-image.svg",
    contentImgAlt: "سامانه تحلیل و پایش امنیتی (SOC)",
    contentImgTitle: "سامانه تحلیل و پایش امنیتی (SOC)",
    link: "/soc",
    linkTitle: "آشنایی با راهکار SOC آبالون",
    alt: "سامانه تحلیل و پایش امنیتی (SOC)",
    contentItem: [
      {
        name: "سامانه‌های مدیریت و تحلیل رخداد (SIEM/XDR/EDR)",
      },
      {
        name: "سامانه‌های حفاظت پیرامونی (IDS/IPS)",
      },
      {
        name: "تیم متخصص تحلیل امنیتی شبانه‌روزی",
      },
      {
        name: "ایده‌آل برای مراکز حساس به داده و زیرساخت‌های حیاتی",
      },
    ],
  },
  {
    title: "سیستم مدیریت اطلاعات و رویدادهای امنیتی (SIEM)",
    img: "security/18.svg",
    imgAlt: "سیستم مدیریت اطلاعات و رویدادهای امنیتی (SIEM)",
    imgTitle: "سیستم مدیریت اطلاعات و رویدادهای امنیتی (SIEM)",
    img_deactive: "security/18.svg",
    section_title: "سیستم مدیریت اطلاعات و رویدادهای امنیتی (SIEM)",
    caption:
      "راهکار SIEM آبالون با گردآوری و تحلیل متمرکز لاگ‌ها و رویدادهای امنیتی، دید کامل و یکپارچه‌‌ای از وضعیت امنیت ابری زیرساخت شما ارائه می‌دهد. این سرویس با شناسایی تهدیدات ناشناخته، هشداردهی بلادرنگ و ارسال گزارش‌های امنیتی منطبق با لاگ‌های سایر سامانه‌ها، امکان واکنش سریع تیم‌های SOC به حملات سایبری را تسهیل می‌کند.",
    contentImg: "VPS/vps-hourly.svg",
    contentImgAlt: "سیستم مدیریت اطلاعات و رویدادهای امنیتی (SIEM)",
    contentImgTitle: "سیستم مدیریت اطلاعات و رویدادهای امنیتی (SIEM)",
    link: "/siem",
    linkTitle: "آشنایی با راهکار SIEM آبالون",
    alt: "سیستم مدیریت اطلاعات و رویدادهای امنیتی (SIEM)",
    contentItem: [
      {
        name: "گردآوری و تحلیل بلادرنگ رویدادهای امنیتی",
      },
      {
        name: "شناسایی تهدیدات پیچیده و ناشناخته",
      },
      {
        name: "تیم متخصص تحلیل امنیتی داشبوردهای گرافیکی برای پایش امنیتی",
      },
      {
        name: "تولید گزارش‌های دقیق برای ممیزی و تطابق",
      },
    ],
  },
  {
    title: "فضای کاری امن آبالون",
    img: "windowsVps/waf.svg",
    imgAlt: "فضای کاری امن آبالون",
    imgTitle: "فضای کاری امن آبالون",
    img_deactive: "windowsVps/waf.svg",
    section_title: "فضای کاری امن آبالون",
    caption:
      "پلتفرم فضای کاری امن آبالون، راهکاری ابری و حفاظت‌شده برای دسترسی ایمن کاربران به محیط کاری از طریق دسکتاپ مبتنی بر مرورگر است. این پلتفرم می‌تواند به‌صورت On-premises بر بستر سرورهای داخلی سازمان یا روی زیرساخت ابری آبالون پیاده‌سازی شود و با افزایش سطح امنیت ابری، لایه‌ای امن میان کاربر و منابع داخلی ایجاد ‌کند.",
    contentImg: "enterprise-services/benefit.svg",
    contentImgAlt: "فضای کاری امن آبالون",
    contentImgTitle: "فضای کاری امن آبالون",
    link: "/secure-workspace",
    linkTitle: "آشنایی با فضای کاری امن آبالون",
    alt: "فضای کاری امن آبالون",
    contentItem: [
      {
        name: "دسکتاپ ایمن مبتنی بر مرورگر بدون نیاز به نصب نرم‌افزار",
      },
      {
        name: "ضبط فعالیت کاربر هنگام اتصال به منابع سازمانی",
      },
      {
        name: "جلوگیری از انتقال فایل، کپی‌برداری و نشت داده",
      },
      {
        name: "پشتیبانی از MFA و سیاست‌های کنترلی دسترسی",
      },
    ],
  },
];

export const cdnCoverage = [
  {
    title: "۹۵٪ کاهش",
    cap: "آسیب‌پذیری‌های وب در لایه اپلیکیشن",
  },
  {
    title: "۵۰۰ میلیون",
    cap: "درخواست پردازش‌شده در هر ساعت",
  },
  {
    title: "۲ ترابیت بر ثانیه",
    cap: "ظرفیت مقابله با حملات سایبری",
  },
  {
    title: "۷۰٪ کاهش",
    cap: " ریسک نشت داده با نظارت PAM",
  },
];

export const secureConnection = [
  {
    title: "امنیت ابری یکپارچه",
    desc: "بدون تداخل و هماهنگ با سایر خدمات ابری آبالون",
    logo: "disaster.svg",
    imgAlt: "امنیت ابری یکپارچه",
    imgTitle: "امنیت ابری یکپارچه",
  },
  {
    title: "پشتیبانی مستمر",
    desc: "پشتیبانی یکپارچه و شبانه‌روزی راهکارهای امنیتی",
    logo: "startup.svg",
    imgAlt: "پشتیبانی مستمر",
    imgTitle: "پشتیبانی مستمر",
  },
  {
    title: "آغاز امن مهاجرت",
    desc: "فعال، از لحظه شروع مهاجرت به فضای ابری",
    logo: "virtualOrganization.svg",
    imgAlt: "آغاز امن مهاجرت",
    imgTitle: "آغاز امن مهاجرت",
  },
  {
    title: "انتخاب هوشمندانه",
    desc: "بدون نیاز به تجهیزات فیزیکی یا مدیریت تیم داخلی.",
    logo: "test.svg",
    imgAlt: "انتخاب هوشمندانه",
    imgTitle: "انتخاب هوشمندانه",
  },
];

export const PopularServices = [
  {
    title: "سرور اختصاصی",
    desc: "با خرید سرور اختصاصی آبالون، به منابع سخت‌افزاری قدرتمند در دیتاسنترهای پیشرفته سراسر کشور به‌صورت Bare Metal یا با معماری ابری دسترسی داشته باشید.",
    logo: "VPS-Service.svg",
    route: "/dedicated-server",
  },
  {
    title: "خدمات محافظت از DDoS",
    desc: "با شناسایی هوشمند و مسدودسازی خودکار ترافیک مخرب، بدون نیاز به تجهیزات سخت‌افزاری، از وب‌سایت‌ها و سرویس‌های آنلاین خود در برابر حملات DDoS محافظت کنید.",
    logo: "VPC-Service.svg",
    route: "/ddos-protection",
  },
  {
    title: "راهکار WAF آبالون",
    desc: "با استفاده از WAF ابری آبالون از اپلیکیشن‌ها و وب‌سایت‌های خود در برابر تهدیدات پیچیده، حملات تزریق کد، و سوء‌استفاده از آسیب‌پذیری‌ها محافظت کنید.",
    logo: "ManagedService-Service.svg",
    route: "/waf",
  },
  {
    title: "دیتاسنتر ابری",
    desc: "دیتاسنتر ابری تمامی قابلیت‌های یک دیتاسنتر فیزیکی را روی ابر برایتان فراهم می‌کند و می‌تواند پاسخی برای پیچیده‌ترین و تخصصی‌ترین نیازهای ابری شما باشد.",
    logo: "DNS.svg",
    route: "/vpc",
  },
];

export const questions = [
  {
    title: "امنیت ابری آبالون شامل چه سرویس‌هایی می‌شود؟",
    answer:
      "امنیت ابری آبالون مجموعه‌ای یکپارچه از سرویس‌هایی چون فضای کاری امن، سامانه SIEM، محافظت در برابر حملات DDoS، فایروال لایه ۳ و ۴، فایروال وب اپلیکیشن (WAF)، سامانه تحلیل و پایش امنیتی (SOC) و سرویس PAM ابری را بدون نیاز به تجهیزات سخت‌افزاری ارائه می‌دهد.",
  },
  {
    title: "امنیت ابری آبالون با چه نوع تهدیداتی مقابله می‌کند؟",
    answer:
      "این راهکار از منابع شما در برابر حملات پیچیده‌ای مانند حملات حجمی (Volume-based)، تزریق کد (SQL Injection)، حملات لایه اپلیکیشن (لایه ۷)، سوءاستفاده از فایل‌ها، دسترسی‌های غیرمجاز و تهدیدات داخلی حساب‌های کاربری ممتاز محافظت می‌کند.",
  },
  {
    title: "آیا سامانه SOC آبالون فقط برای دیتاسنترهای آبالون کاربرد دارد؟",
    answer:
      "خیر، SOC آبالون می‌تواند به طور هم‌زمان از منابع میزبانی‌شده در دیتاسنترهای آبالون یا زیرساخت داخلی سازمان شما محافظت کند و امنیت ابری را برای هر دو نوع زیرساخت فراهم کند.",
  },
  {
    title:
      "مزیت اصلی استفاده از امنیت ابری آبالون نسبت به راهکارهای سنتی چیست؟",
    answer:
      "امنیت ابری آبالون یک سیستم دفاعی چندلایه، مقیاس‌پذیر و خودکار است که همزمان با رشد زیرساخت ابری سازمان، به‌روزرسانی می‌شود و از لحظه مهاجرت به ابر، پوشش امنیتی کامل ارائه می‌دهد.",
  },
];
